module.exports = __webpack_public_path__ + "img/icon-grid-active.262d7fa8.svg";